import ClientService from "../../services/ClientService";
import { AsyncSelect } from "../AsyncSelect/AsyncSelect";

export function OrganizationSelector({
   value,
   onChange,
   required = false,
   ...props
}) {
   async function fetchOrganizations(search, signal) {
      const response = await ClientService.listClientsPaginated(
         1,
         search,
         {
            orderDirection: "ASC",
            collumnTitle: "name",
         },
         signal,
      );

      return response?.data?.items || [];
   }

   async function fetchOrganizationById(id, signal) {
      if (!id) {
         return null;
      }

      const response = await ClientService.getClient(id, signal);

      return response?.data || null;
   }

   return (
      <AsyncSelect
         value={value}
         onChange={onChange}
         fetchOptions={fetchOrganizations}
         fetchOption={fetchOrganizationById}
         getOptionValue={(organization) => organization?.id}
         getOptionLabel={(organization) => organization?.name}
         label={`Organização ${required ? "*" : ""}`}
         placeholder="Selecione uma organização"
         searchPlaceholder="Buscar organização..."
         emptyMessage="Nenhuma organização encontrada."
         {...props}
      />
   );
}
